// Add your custom JS here.

// header js for responisve menu
jQuery(function () {
	var navMain = jQuery(".navbar-collapse");
	jQuery(".navbar-toggler").click(function () {
		jQuery("body").addClass("overflow-hidden");
	});
	jQuery('#navbarNavDropdown').on('click', '#navbar-close', function () {
		jQuery("#navbarNavDropdown").removeClass('show');
		jQuery("body").removeClass("overflow-hidden");
	});


	if (jQuery(window).width() < 1200) {

		jQuery('.navbar-nav li .dropdown-toggle').on('click', function (e) {
			e.preventDefault();  // Prevent default action for the click event
		
			var $submenu = jQuery(this).siblings('.dropdown-menu');
		
			// Close all other open submenus and remove the 'current-menu' class
			jQuery('.navbar-nav li .dropdown-menu').not($submenu).removeClass('show').slideUp();
			jQuery('.navbar-nav li .dropdown-toggle').not(this).removeClass('current-menu');
		
		
		});

jQuery('.navbar-nav li>ul>li>a').on('click', function (e) {
    e.preventDefault();  // Prevent default action for the click event

    var $submenu = jQuery(this).siblings('.dropdown-menu');

    // Close all other open submenus
    jQuery('.navbar-nav li>ul>li .dropdown-menu').not($submenu).removeClass('show').slideUp();

    // Toggle the clicked submenu
    $submenu.toggleClass('show');
});
	}

	jQuery('.navbar-nav .menu-item-has-children').on('click', function (e) {
		e.stopPropagation();
	});
	jQuery(document).on('click', function () {
		jQuery('.navbar-nav .menu-item-has-children ul').slideUp().parent().removeClass('open');
	});
	jQuery('.navbar-nav').on('click', function (e) {
		e.stopPropagation();
	});

	// home page hero slider 
	jQuery('.slider').slick({
		autoplay: false,
		speed: 300,
		lazyLoad: 'progressive',
		arrows: true,
		dots: true,
		prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
		nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
	}).slickAnimation();



	jQuery('.slick-nav').on('click touch', function (e) {

		e.preventDefault();

		var arrow = jQuery(this);

		if (!arrow.hasClass('animate')) {
			arrow.addClass('animate');
			setTimeout(() => {
				arrow.removeClass('animate');
			}, 1600);
		}

	});


	background();



});
function background() {
	var img = jQuery('.sliderimage');
	img.css('background-image', function () {
		var bg = ('url(' + jQuery(this).data('background') + ')');
		return bg;
	});
}